import { Button } from 'components/commons';
import ButtonGroup from 'components/button-group';
import InputText from 'components/inputtext';
import Title from 'components/title';
import { Dropdown } from 'primereact/dropdown';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import ZipCodeInput from './zipcodeinput-layout';

type optionType = {
    value: string,
    label: string
};

type addressType = {
    street: string;
    number: string;
    complement: string;
    neighbourhood: string;
}

type AddressProps = {
    zipCode: string;
    setZipCode: Dispatch<SetStateAction<string>>;
    selectedUf: optionType;
    setSelectedUf: Dispatch<SetStateAction<optionType>>;
    selectedCity: optionType;
    setSelectedCity: Dispatch<SetStateAction<optionType>>;
    statesLoading: boolean;
    statesOptions: Array<optionType>;
    citiesLoading: boolean;
    citiesOptions: Array<optionType>;
    isValidFields: boolean;
    loading: boolean;
    goToPreviousRoute: () => void;
    handleSubmit: () => void;
    handleBlur: (e: ChangeEvent<HTMLInputElement>) => void;
    handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
    formData: addressType;
}


const AddressLayout: React.FC<AddressProps> = ({
    zipCode,
    setZipCode,
    selectedUf,
    setSelectedUf,
    selectedCity,
    setSelectedCity,
    goToPreviousRoute,
    handleSubmit,
    statesLoading,
    statesOptions,
    citiesLoading,
    citiesOptions,
    isValidFields,
    loading,
    handleBlur,
    handleInputChange,
    formData
}: AddressProps): JSX.Element => {
    return (
        <div className="address-page">
            <Title className="mt-4">
                confirme o endereço <br className="d-block d-sm-none" /> da empresa
            </Title>

            <ZipCodeInput
                {...{
                    zipCode,
                    setZipCode,
                    loading,
                    handleBlur
                }}
            />

            <InputText
                value={formData.street || ""}
                name="street"
                className="grid-street-field"
                maxLength={40}
                label="Logradouro"
                onChange={handleInputChange}
            />

            <InputText
                value={formData.number}
                id="number"
                className="grid-number-field"
                type="tel"
                label="Número"
                onChange={handleInputChange}
            />

            <InputText
                value={formData.complement}
                id="complement"
                className="grid-complement-field"
                maxLength={40}
                label="Complemento"
                onChange={handleInputChange}
            />

            <InputText
                value={formData.neighbourhood}
                id="neighbourhood"
                className="grid-neighbourhood-field"
                label="Bairro"
                onChange={handleInputChange}
            />

            <Dropdown
                value={selectedUf && selectedUf.value}
                disabled={statesLoading}
                className="grid-state-field dropdown"
                options={statesOptions}
                placeholder="Estado"
                id="state"
                onChange={(e) => setSelectedUf(e.target.value)}
            />

            <Dropdown
                value={selectedCity && selectedCity.value}
                disabled={citiesLoading}
                className="grid-city-field dropdown"
                options={citiesOptions}
                placeholder="Cidade"
                id="city"
                onChange={(e) => setSelectedCity(e.target.value)}
            />

            <ButtonGroup className="buttons-group-mobile">
                <Button
                    label="voltar"
                    variant="secondary"
                    type="button"
                    onClick={goToPreviousRoute}
                />

                <Button
                    label="continuar"
                    disabled={!isValidFields}
                    onClick={handleSubmit}
                />
            </ButtonGroup>
        </div>
    )
}

export default AddressLayout;
